import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import classNames from 'classnames';
import classes from './CardTextB.module.scss';

const CardTextB = (props) => {
  const {
    heading,
    link,
    contentMarkup,
  } = props;

  const isLink = link && link.href;

  return (
    <div className={classes.container}>
      <a
        aria-label={heading}
        href={link && link.href}
        target={link && link.target}
        className={classNames(!isLink ? classes.unlink : classes.link, { [classes.containerLink]: isLink })}
      >
        <div className={classes.contentWrapper}>
          {heading &&
            <h2
              className={classes.heading}
              dangerouslySetInnerHTML={{ __html: heading }}
            />}
          {contentMarkup &&
            <div
              className={classes.contentMarkup}
              dangerouslySetInnerHTML={{ __html: contentMarkup }}
            />}
        </div>
        <div className={classes.iconWrapper}>
          <FontIcon icon='far fa-angle-right' className={classes.icon} />
        </div>
      </a>
    </div>
  );
};

CardTextB.propTypes = {
  /**
   * Heading on the card
  */
  heading: PropTypes.string,
  /**
   * Content of the card
  */
  contentMarkup: PropTypes.string,
  /**
   * Link used to redirect users if clicking on the card
  */
  link: PropTypes.shape({
    target: PropTypes.string,
    title: PropTypes.string,
    href: PropTypes.string,
  }),
};

export default CardTextB;
